export interface Session {
    sessionId: string ;
     userId:string ;
     team1name: string ;
    team2name: string ;
    team1score: number ;
     team2score: number ;
     sessionStatus: SessionStatus ;
    powerups: {
        team1: number;
        team2: number;
    };  
   gameCategories:  string[]  ;
   team1Powerups:TeamPowerup[];
   team2Powerups :TeamPowerup[];
   sessionType?: SessionType;

categoryQuestionsMap: Map<string, SessionQuestions[]>;

}
export enum SessionStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED'
}

export enum SessionType {
    FREE = "FREE",
    PAYED = "PAYED"
}

export interface SessionQuestions {
  questionId:       string ;
   categoryId:  string ;
   answered:  boolean ;
   answeredByTeam:  string ;
   answeredCorrectly:  boolean ;
    pointsAwarded: number ;
  difficulty :  Difficulty ;
}

export enum Difficulty {
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD'
}


export interface TeamPowerup {
  type: PowerupType;
  used: boolean;
  active: boolean;
}

export enum PowerupType {
  MINUS_FIFTY_PERCENT = "MINUS_FIFTY_PERCENT",
  NO_ANSWER = "NO_ANSWER",
  DOUBLE_OR_MINUS = "DOUBLE_OR_MINUS"
}